import { createSlice } from "@reduxjs/toolkit";
const EMPTY_ARRAY = []; // Stable reference
const userAccessDataSlice = createSlice({
	name: "userAccessData",
	initialState: {
		data: null, // Will hold the full response
		loading: false,
		error: null,
	},
	reducers: {
		fetchUserAccessDataRequest: (state) => {
			state.loading = true;
			state.error = null;
		},
		fetchUserAccessDataSuccess: (state, action) => {
			state.loading = false;
			state.data = action.payload; // Store full response
		},
		fetchUserAccessDataFailure: (state, action) => {
			state.loading = false;
			state.error = action.payload;
		},
	},
});

// Selectors - use these in your components
export const selectUserMenus = (state) => state.userAccessData.data?.userMenus || EMPTY_ARRAY;
export const selectUserRoleIds = (state) => state.userAccessData.data?.data?.userRoleIds || EMPTY_ARRAY;
export const selectUserPermissionIds = (state) => state.userAccessData.data?.userPermissionIds || EMPTY_ARRAY;
export const selectUserActions = (state) => state.userAccessData.data?.userActions || EMPTY_ARRAY;
export const selectUserWorkflowActions = (state) => state.userAccessData.data?.userWorkflowActions || EMPTY_ARRAY;

export const { fetchUserAccessDataRequest, fetchUserAccessDataSuccess, fetchUserAccessDataFailure } = userAccessDataSlice.actions;

export default userAccessDataSlice.reducer;
